import {MeterEntity, MeterSelectorProps, metersSelector, useGetAllMetersQuery} from "@ots-frontend/ots-data";
import {BaseMeterMultiSelect, BaseMeterMultiSelectProps} from "./BaseMeterMultiSelect";
import {useMemo, useState} from "react";
import {Box, Button, Modal, ModalProps} from "@mantine/core";
import {useTranslation} from "react-i18next";

export type MeterMultiSelectProps = Omit<BaseMeterMultiSelectProps, "entities" | "loading"> & {
  selector?: MeterSelectorProps
}

export const MeterMultiSelect = (props: MeterMultiSelectProps) => {
  const {
    selector,
    ...rest
  } = props;

  const selectMeters = useMemo(() => {
    return metersSelector()
  }, []);

  const {meters, isLoading} = useGetAllMetersQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      meters: selectMeters(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseMeterMultiSelect entities={meters} loading={isLoading} {...rest} />;
};

export interface MeterMultiSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: MeterMultiSelectProps,
  onSubmit?: (meters: MeterEntity[] | undefined) => void
}

export const MeterMultiSelectModal = (props: MeterMultiSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedMeters, setSelectedMeters] = useState<MeterEntity[]>([])

  const {t} = useTranslation(["common"]);

  return (
    <Modal {...rest}>
      <Box>
        <MeterMultiSelect
          {...select}
          onEntityChange={e => setSelectedMeters(e)}/>
        <Button type="submit" mt="xl" onClick={(e) => {
          if (onSubmit) {
            onSubmit(selectedMeters);
          }
        }}>
          {t("common.action.submit")}
        </Button>
      </Box>
    </Modal>
  );
};
